import { Inject, Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { MOCKS } from '../../../response-mocks';
import { constants } from '../../../constants/constants';

@Injectable()
export class MockingService {
	constructor(@Inject(MOCKS) private _mockGroups: any, private _router: Router) {
		this._router.events.subscribe(event => {
			if (event instanceof NavigationStart) {
				this.updateMockIds();
			}
		});
	}

	getResponse(serviceUrl: string): any {
		const mockId = window.sessionStorage.getItem(constants.SESSION_STORAGE_KEYS.MOCK_ID);
		const mockGroupIndex = window.sessionStorage.getItem(constants.SESSION_STORAGE_KEYS.MOCK_GROUP_INDEX);

		if (mockId && mockGroupIndex) {
			return this._mockGroups[mockId][mockGroupIndex][serviceUrl];
		}

		return null;
	}

	private updateMockIds() {
		// i.e. &mock=oe:1
		const queryParamsMap = this.parseQueryString();

		let mockParams: any = (queryParamsMap as any)['mock'];
		if (mockParams) {
			if (mockParams === 'clear') {
				window.sessionStorage.removeItem(constants.SESSION_STORAGE_KEYS.MOCK_ID);
				window.sessionStorage.removeItem(constants.SESSION_STORAGE_KEYS.MOCK_GROUP_INDEX);
			} else {
				mockParams = mockParams.split(':');

				const mockId = mockParams[0];
				const mockGroupIndex = mockParams[1];

				window.sessionStorage.setItem(constants.SESSION_STORAGE_KEYS.MOCK_ID, mockId);
				window.sessionStorage.setItem(constants.SESSION_STORAGE_KEYS.MOCK_GROUP_INDEX, mockGroupIndex.toString());
			}
		}

		// i.e. &timeoutMock=50000
		// See https://jira.rccl.com/browse/OLCI-14225
		const timeoutMockParams = (queryParamsMap as any)['timeoutMock'];
		if (timeoutMockParams) {
			window.sessionStorage.setItem(constants.SESSION_STORAGE_KEYS.TIMEOUTMOCK_MILLISECONDS, timeoutMockParams);
		}
	}

	private parseQueryString(queryString?: string): Map<string, string> {
		// if the query string is NULL
		if (!queryString) {
			queryString = window.location.search.substring(1);
		}

		const params = new Map<string, string>();
    const queries = queryString.split('&');

		queries.forEach((indexQuery: string) => {
			const indexPair = indexQuery.split('=');
			const queryKey = decodeURIComponent(indexPair[0]);
			const queryValue = decodeURIComponent(indexPair.length > 1 ? indexPair[1] : '');
			(params as any)[queryKey] = queryValue;
		});

		return params;
	}
}
